import React from "react";

let Loading = require("./loading");
let UploadSlat = require("./moderation-uploads-slat");

class ModerationUploadSlats extends React.Component {
    render() {
        let uploadArray = [];

        if (this.props.batch.uploads.length > 0) {
            this.props.batch.uploads.forEach(upload => {
                uploadArray.push(
                    <UploadSlat key={upload.id} upload={upload} />
                );
            });
        } else {
            if (this.props.batch.result === "SEARCH_UPLOADS_SUCCESS") {
                return <div className="no-results"><h3>No Results</h3></div>;
            } else {
                if (this.props.batch.result === "FETCH_NEW_UPLOADS_SUCCESS") {
                    return (
                        <div className="no-results">
                            This is insane! There aren't any new uploads to review at the moment! Pat yourself on the back!🍻
                        </div>
                    );
                } else {
                    return <Loading />;
                }
            }
        }

        return (
            <section className="creator-slats">
                {uploadArray}
            </section>
        );
    }
}

module.exports = ModerationUploadSlats;
